<template>
  <div class="d-flex align-center">
    <v-select
      v-model="selectedPartner"
      class="partners-select ma-md-2 mt-1"
      dark
      background-color="primary"
      :items="partnersList"
      placeholder="Partner"
      :item-value="item => item"
      item-text="name"
      single-line
      solo
      dense
    />
    <div v-if="selectedPartner">
      Base Currency: <b>{{ selectedPartner.baseCurrency }}</b>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SelectPartners",

    props: {
      partnerName: {
        type: String,
        required: true
      },
      partnersList: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        selectedPartner: {},
      }
    },

    watch: {
      selectedPartner: {
        handler(newValue) {
          this.onChangedSelectedPartner(newValue);
        }
      }
    },

    mounted() {
      const selectedPartnerItem = this.partnersList.find((item) => {
          return item.name === this.partnerName;
        });

      this.$set(this, "selectedPartner", selectedPartnerItem);
    },

    methods: {
      onChangedSelectedPartner (value) {
        this.$emit('on-change-partner', value);
      }
    }
  }
</script>

<style scoped lang="scss">
.partners-select {
  min-width: 250px;
  max-width: 250px;
  height: 38px;
}
</style>
